<template>
      <div> 
      <Row>
        <i-col span="22">
    <Form ref="formInline" label-position="right" :label-width="60" :model="formInline"  inline>
        <FormItem prop="user" label="关键字">
            <i-input type="text" v-model="formInline.keywords" placeholder="关键字"></i-input>
        </FormItem>
         <!-- <FormItem prop="user" label="支付代码">
            <i-input type="text" v-model="paymethod_code" placeholder="关键字"></i-input>
        </FormItem> -->
         <FormItem>
            <Button type="primary" @click="getlist" title="adminsearch">查询</Button>
        </FormItem>
         </Form>
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add" v-if="privilegesbtn('/paymethod/company_create')">新增</Button>  
        </i-col>
    </Row>
     <Tabs v-model="paymethod_code" @on-click='getlist'>
       <template v-for="data in codelist">
        <TabPane :label='data.name' :name="data.id"  :key="data.id">
        <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
        </TabPane>
       </template>
    
        <!-- <TabPane label="支付宝"  name="alipay"><Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
        </TabPane> -->
        
    </Tabs>

    </div>
</template>
<script>
import { paymethodcompany, companydeletepay } from "../../api/paymethodapi";
import { company_privileges } from "../../api/privilegesapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      type: "",
      isupdte: privilegesbtn("/paymethod/company_update"),
      isdelete: privilegesbtn("/paymethod/company_delete"),
      paymethod_code: "wechat",
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          title: "集团名称",
          key: "name",
          align: "center"
        },
        {
          title: "支付方式参数",
          key: "data",
          align: "center"
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled:(!this.isupdte)
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled:(!this.isdelete)
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  computed: {
    ...mapState({
      codelist: state => state.paycode
    })
  },
  methods: {
    privilegesbtn:privilegesbtn,
    add() {
      this.$router.push({ path: "companyaddpay" });
    },
    show(params) {
      var param = {
        code: this.paymethod_code,
        data: params.data,
        id: params.id,
        name: params.name
      };
      this.$router.push({ path: "companyupdtepay", query: param });
    },
    getlist() {
      var par = {
        paymethod_code: this.paymethod_code,
        page: this.page,
        pagesize: this.pagesize,
        keywords: this.formInline.keywords
      };
      this.$Loading.start();
      paymethodcompany(par).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
    changePage(row) {
      this.page = row;
      this.getlist();
    },
    remove(id) {
      let self = this;
      this.$Modal.confirm({
        title: "集团支付权限列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();

          let para = {
            company_id: id,
            paymethod_code: self.paymethod_code
          };
          companydeletepay(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    }
  },
  mounted() {
    this.getlist();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/System/paymethodcompany.vue